// @ts-nocheck
import React, { useState, useEffect } from 'react';

import UsersList from './components/UsersList';
import ActionBar from '../../layout/ActionBar';
import AddUser from './slideout/AddUser';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { getAllCompanyTypes } from '../../../reducers/companyTypeReducer';

function Users() {
  usePageTitle(['Users']);

  const companyTypes = useAppSelector((state) => state.companyTypes);
  const connectedUsers = useAppSelector((state) => state.connectedUsers);
  const dispatch = useAppDispatch();

  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();
  const [inviteSlideoutOpen, setInviteSlideoutOpen] = useState(false);

  //companies
  useEffect(() => {
    if (!companyTypes) {
      dispatch(getAllCompanyTypes()).catch((e) => { });
    }
  }, [companyTypes, dispatch]);

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={() => setInviteSlideoutOpen(true)}
          text={t('Invite user')}
        />
      </ActionBar>
      <UsersList
        reload={reload}
        companyTypes={companyTypes}
        connectedUsers={connectedUsers}
      />

      <SlidingPane
        isOpen={inviteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="side-panel"
        onRequestClose={() => setInviteSlideoutOpen(false)}
      >
        <AddUser
          cancel={() => setInviteSlideoutOpen(false)}
          done={(d) => {
            setInviteSlideoutOpen(false);
            setReload(new Date());
          }}
        />
      </SlidingPane>
    </>
  );
}

export default Users;
